/**
 * @file Flush queue reducer.
 */

import { SET_FLUSH_MODE } from '../actions/flush-queue-actions';
import { FLUSH_MODE_COLS } from '../../constants/command';

const initialState = {
  flushQueue: [],
  flushMode: FLUSH_MODE_COLS.TWO,
};

const flushQueueReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FLUSH_MODE:
      return {
        ...state,
        flushMode: action.flushMode,
      };

    default:
      return state;
  }
};

export { initialState };
export default flushQueueReducer;
